var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.css()},[_vm._v(_vm._s(_vm.timeago))])}
var staticRenderFns = []

export { render, staticRenderFns }